var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',_vm._g(_vm._b({class:[( _obj = {}, _obj[_vm.$style.chip] = !_vm.light_color, _obj )],attrs:{"color":_vm.color_by_status,"outlined":!_vm.is_filled_bg,"small":""}},'v-chip',_vm.$attrs,false),_vm.$listeners),[_vm._l((_vm.$slots),function(_,name){return _vm._t(name,null,{"slot":name})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }